import { useState, useRef } from "react";

export const useTooltip = () => {
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef(null);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return {
    isVisible,
    targetRef,
    showTooltip,
    hideTooltip,
  };
}; 